export const reviews = [
  {
    name: 'Samira K.',
    product: 'hammam-ritueel-set',
    text: 'Eindelijk een set die gewoon uitlegt wat je moet doen. Mijn huid voelt na één keer al anders.',
    rating: 5,
  },
  {
    name: 'Daan V.',
    product: 'arganolie',
    text: 'Gebruik het voor mijn baard en na het douchen. Geen parfumlucht, gewoon pure olie.',
    rating: 5,
  },
  {
    name: 'Noor B.',
    product: 'kessa',
    text: 'Niet te vergelijken met een gewone scrub. Dag besteld, volgende ochtend in de bus.',
    rating: 5,
  },
]
